export const DAYS = [30, 90, 180, 365];
